import service from "./index";

//搜索结果
export const getAllList = (data) => {
    return service({
        url:"/open/portal/search/allList",
        method:'post',
        data
    })
}